import { z } from 'zod';

export const startProductImportOkSchema = z.object({
    ok: z.literal(true),
    runId: z.string().uuid(),
    channel: z.string().min(1),
});

export type StartProductImportOkSchema = z.infer<typeof startProductImportOkSchema>;

export const startProductImportErrorSchema = z.object({
    ok: z.literal(false),
    errors: z.array(z.string().min(1)).min(1),
});

export type StartProductImportErrorSchema = z.infer<typeof startProductImportErrorSchema>;
